module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data),
      expression: "data"
    }],
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.data)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e0a3e1e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Xieyi.vue
// module id = 615
// module chunks = 1